import {
  SpacerBuilderSettingsTableRow,
  SpacerPositionOption,
  SpacerTypeOption,
} from '@warebee/shared/data-access-layout-import-converter';
import { useTranslation } from 'react-i18next';
import { ColumnConfig } from '../../../../components/DatasetTable';
import Tag from '../../../../helpContext/Tag';
import {
  getSpacerPositionOptionMap,
  getSpacerTypeOptionMap,
} from '../store/converter.types';

function useConverterSpacersTableConfig(): ColumnConfig<SpacerBuilderSettingsTableRow>[] {
  const { t } = useTranslation('designer');
  const spacerTypeOptions = getSpacerTypeOptionMap(t);
  const spacerPositionOptions = getSpacerPositionOptionMap(t);
  const columnsConfig: ColumnConfig<SpacerBuilderSettingsTableRow>[] = [
    {
      field: 'title',
      title: t`Bay`,
      hasFilter: true,
    },
    {
      field: 'areaId',
      title: t`Area`,
      hasFilter: true,
    },

    {
      field: 'position',
      title: t`Side`,
      hasFilter: true,
      filterOptions: Object.fromEntries(spacerPositionOptions),
      render: (v: SpacerPositionOption) => (
        <Tag title={spacerPositionOptions.get(v)}>
          {spacerPositionOptions.get(v)}
        </Tag>
      ),
    },
    {
      field: 'type',
      title: t`Type`,
      hasFilter: true,
      filterOptions: Object.fromEntries(spacerTypeOptions),
      render: (v: SpacerTypeOption) => (
        <Tag title={spacerTypeOptions.get(v)}> {spacerTypeOptions.get(v)} </Tag>
      ),
    },
    {
      field: 'width',
      title: t`Width`,
      hasFilter: true,
    },

    {
      field: 'id',
      title: t`ID`,
      hasFilter: true,
    },
    {
      field: 'bayId',
      title: t`Bay ID`,
      hasFilter: true,
    },
  ];

  return columnsConfig;
}
export default useConverterSpacersTableConfig;
